<template>
  <div>
    <h1 class="display-4">Liste des événements</h1>
    <hr />

    <b-tabs content-class="mt-3" fill>
      <b-tab title="Vue liste" active>
        <div class="row">
          <div class="col-md-11">
          </div>
          <div class=" col-md-1">
            <button class="btn btn-primary" @click.prevent="showingFilter"><font-awesome-icon icon="filter" class="right" v-b-popover.hover.bottom="'Cliquez pour afficher/cacher les filtres'"></font-awesome-icon> <sup><b-badge pill variant="light">{{ numberFilter }}</b-badge></sup></button>
          </div>
        </div>

        <h4 class="my-4">Filtres</h4>
        <b-row class="mt-3" v-show="showFilter">
          <b-col md="4" class="my-1">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Rechercher" />
              <b-input-group-append>
                <b-btn :disabled="!filter" variant="primary" @click="filter = ''">Effacer</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group label-cols-sm="3" label-align-sm="right" label="Résultats par page" class="mb-0">
              <b-form-select :options="pageOptions" v-model="perPage" />
            </b-form-group>
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group id="showEvent" label-cols-sm="2" label="Afficher :" class="mb-0">
              <b-form-select :options="showOptions" v-model="showActive"></b-form-select>
            </b-form-group>
          </b-col>
          <!-- <b-col md="3" class="my-1">
            <b-form-group id="exampleGroup4">
              <b-form-checkbox-group id="exampleChecks">
                <b-form-checkbox v-model="showInactive" value="true" unchecked-value="false">Afficher les événements inactifs et supprimés</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col md="3" class="my-1">
            <b-form-group id="exampleGroup4">
              <b-form-checkbox-group id="exampleChecks">
                <b-form-checkbox v-model="showPassed" value="true" unchecked-value="false">Afficher les événements passés</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col> -->
          <b-col :md="columnFilter" class="my-1" v-show="schools.length > 1">
            <label for="School">Ecole</label>
            <select class="form-control" id="School" @change="updateFilter(); updateType(); updateLabel();" v-model="schoolId">
              <option value="">---</option>
              <option v-for="item in schools" :value="item.id" :key="item.id">{{ item.name }}</option>
            </select>
          </b-col>
          <b-col :md="columnFilter" class="my-1" v-show="cities.length > 1">
            <label for="Cities">Ville</label>
            <select class="form-control" id="Cities" @change="updateFilter" v-model="cityId">
              <option value="">---</option>
              <option v-for="item in cities" :value="item.id" :key="item.id">{{ item.name }}</option>
            </select>
          </b-col>
          <b-col :md="columnFilter" class="my-1">
            <label for="Types">Type d'événement</label>
            <select class="form-control" id="Types" @change="updateFilter(); updateLabel();" v-model="typeId">
              <option value="">---</option>
              <option v-for="item in types" :value="item.id" :key="item.id">{{ item.name }}</option>
            </select>
          </b-col>
          <b-col :md="columnFilter" class="my-1" v-show="showLabel">
            <label for="Labels">Label d'événement</label>
            <select class="form-control" id="Labels" @change="updateFilter" v-model="labelId">
              <option value="">---</option>
              <option v-for="item in labels" :value="item.id" :key="item.id">{{ item.name }}</option>
            </select>
          </b-col>
          <b-col :md="columnFilter" class="my-1">
            <b-row>
              <b-col cols="6">
                <label for="date_debut">Date de début</label>
                <datepicker id="date_debut" v-model="date_debut" input-class="form-control" format="dd/MM/yyyy" placeholder="---" :language="fr" :monday-first="true" :clear-button="true" @change="updateFilter"></datepicker>
              </b-col>
              <b-col cols="6">
                <label for="date_fin">Date de fin</label>
                <datepicker id="date_fin" v-model="date_fin" input-class="form-control" format="dd/MM/yyyy" placeholder="---" :language="fr" :monday-first="true" :clear-button="true" @change="updateFilter"></datepicker>
              </b-col>
            </b-row>
          </b-col>
          <b-col :md="columnFilter" class="my-1" v-show="hasFilter">
            <label>&nbsp;</label><br />
            <b-btn variant="danger" @click.prevent="emptyFilter">Vider le filtre</b-btn>
          </b-col>
          <b-col cols="3" class="my-1" v-show="role == 'admin'">
            <label for="User">Créateur de l'événement</label>
            <select class="form-control" id="User" @change="updateFilter" v-model="ionisId">
              <option value="">---</option>
              <option v-for="item in users" :value="item.id" :key="item.id" v-show="item.role != 'API'">{{ item.first_name + ' ' + item.last_name }}</option>
            </select>
          </b-col>
          <b-col cols="2" class="my-5" v-show="isAdvance">
            <!-- <label for="Advance">Evénement spécifique Concours Advance</label> -->
            <b-form-checkbox
              id="checkboxAdvance"
              v-model="advance"
              name="checkboxAdvance"
            >
              Evénements spécifiques Concours Advance
            </b-form-checkbox>
          </b-col>
          <b-col cols="2" class="my-5" v-show="isAdvance">
            <!-- <label for="Advance">Evénement spécifique Concours Advance</label> -->
            <b-form-checkbox
              id="checkboxAdvancePara"
              v-model="advancePara"
              name="checkboxAdvancePara"
            >
              Evénements spécifiques Advance Parallèle
            </b-form-checkbox>
          </b-col>
          <b-col cols="2" class="my-5" v-show="isCpge">
            <!-- <label for="Advance">Evénement spécifique Concours Advance</label> -->
            <b-form-checkbox
              id="checkboxCpge"
              v-model="cpge"
              name="checkboxCpge"
            >
              Evénements spécifiques Concours CPGE
            </b-form-checkbox>
          </b-col>
          <b-col cols="2" class="my-5" v-show="isBachelor">
            <!-- <label for="Advance">Evénement spécifique Concours Advance</label> -->
            <b-form-checkbox
              id="checkboxBachelors"
              v-model="bachelor"
              name="checkboxBachelors"
            >
              Evénements spécifiques Advance Bachelors
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col sm="10">
            <router-link tag="span" to="/events/edit">
              <a class="btn btn-large btn-primary">Ajouter un événement</a>
            </router-link>
            <b-dropdown variant="secondary" right split text="Export / import">
              <!-- <b-dropdown-item href="#/events/import"><font-awesome-icon icon="file-import"></font-awesome-icon> Importer plusieurs événements</b-dropdown-item> -->
              <b-dropdown-item @click.prevent="exportData"><font-awesome-icon icon="file-export"></font-awesome-icon> Exporter tous les événements</b-dropdown-item>
            </b-dropdown>
            <!-- <router-link tag="span" to="/events/import">
              <a class="btn btn-large btn-primary"><font-awesome-icon icon="file-import"></font-awesome-icon> Importer plusieurs événements</a>
            </router-link> -->
            <b-btn variant="danger" v-show="selected.length > 0" @click.prevent="infoDeleteMultiple($event.target)"><font-awesome-icon icon="trash"></font-awesome-icon> {{ selected.length == 1 ? 'Supprimer l\'événement sélectionné' : 'Supprimer les ' + selected.length + ' événements sélectionnés' }}</b-btn>
          </b-col>
          <b-col sm="2">
            <b-alert class="text-center" variant="info" show>
              {{ totalRows }} événements
            </b-alert>
          </b-col>
        </b-row>
        <b-table :busy="isBusy" class="mt-3" :dark="theme == 'dark'" selectable responsive hover striped :items="filter_events" :fields="fields" :current-page="currentPage" :per-page="perPage" select-mode="range" selected-variant="danger" v-show="totalRows > 0" @row-selected="onRowSelected">
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Chargement...</strong>
            </div>
          </template>
          <template slot="start_date" slot-scope="cell">
            {{ cell.item.start_date | formatDate }} <span v-show="cell.item.end_date !== undefined">-</span> {{ cell.item.end_date | formatDate }}
          </template>
          <template slot="active" slot-scope="cell">
            <font-awesome-icon icon="check-circle" class="text-success" v-show="cell.item.active" @click.stop="switchStatus(cell.item)" v-b-popover.hover="'Cliquez pour désactiver l\'événement'" />
            <font-awesome-icon icon="times-circle" class="text-danger" v-show="!cell.item.active && cell.item.date_planned == undefined" @click.stop="switchStatus(cell.item)" v-b-popover.hover="'Cliquez pour activer l\'événement'" />
            <font-awesome-icon icon="clock" class="text-warning" v-show="!cell.item.active && cell.item.date_planned != undefined" @click.stop="switchStatus(cell.item)" v-b-popover.hover="'Cliquez pour activer l\'événement'" />
          </template>
          <template slot="highlight" slot-scope="cell">
            {{ cell.item.highlighted == true ? 'Mis en avant' : '' }}<br v-show="cell.item.highlighted" />
            {{ cell.item.slider == true ? 'Mis en avant slider' : '' }}
            {{ cell.item.highlighted == false && cell.item.slider == false ? 'Aucune mise en avant' : '' }}
          </template>
          <template slot="author" slot-scope="cell">
            {{ cell.item.ionis.first_name }} {{ cell.item.ionis.last_name }}
          </template>
          <template slot="horaire" slot-scope="cell">
            {{ cell.item.start_time }}{{ cell.item.end_time != '' ? '-' : '' }}{{ cell.item.end_time }}
          </template>
          <template slot="actions" slot-scope="cell">
            <b-dropdown
              split
              split-variant="outline-primary"
              variant="primary"
              text="Split Variant Dropdown"
            >
              <template v-slot:button-content>
                <router-link tag="div" :to="{ name: 'EventEditExist', params: {id: cell.item.id } }">
                  <font-awesome-icon icon="cog"></font-awesome-icon>
                </router-link>
              </template>
              <b-dropdown-item :to="{ name: 'EventEditExist', params: {id: cell.item.id } }" v-show="cell.item.date_deleted == undefined"><font-awesome-icon icon="pencil-alt" class="text-primary"></font-awesome-icon> Editer l'événement</b-dropdown-item>
              <b-dropdown-item @click.stop="info(cell.item, cell.index, $event.target); checkCampaignMember([cell.item])" class="mr-1" v-show="cell.item.date_deleted == undefined || role == 'admin'"><font-awesome-icon icon="trash" class="text-danger"></font-awesome-icon> Supprimer l'événement</b-dropdown-item>
              <b-dropdown-item @click.prevent="enableEvent(cell.item)" class="mr-1" v-show="cell.item.date_deleted != undefined && role == 'admin'"><font-awesome-icon icon="trash-restore" class="text-info"></font-awesome-icon> Rétablir l'événement</b-dropdown-item>
              <b-dropdown-item @click.stop="switchStatus(cell.item)" v-show="!cell.item.active"><font-awesome-icon icon="check-circle" class="text-success"></font-awesome-icon> Activer l'événement</b-dropdown-item>
              <b-dropdown-item @click.stop="switchStatus(cell.item)" v-show="cell.item.active"><font-awesome-icon icon="times-circle" class="text-danger"></font-awesome-icon> Désactiver l'événement</b-dropdown-item>
              <b-dropdown-item @click.stop="switchHighlight(cell.item)"><font-awesome-icon icon="arrow-up"></font-awesome-icon> {{ cell.item.highlighted ? 'Ne plus m' : 'M' }}ettre en avant</b-dropdown-item>
              <b-dropdown-item @click.stop="switchHighlightSlider(cell.item)"><font-awesome-icon icon="arrow-up"></font-awesome-icon> {{ cell.item.slider ? 'Ne plus m' : 'M' }}ettre en avant sur le slider</b-dropdown-item>
              <b-dropdown-item @click.stop="scheduleEvent(cell.item, cell.index, $event.target)"><font-awesome-icon icon="calendar"></font-awesome-icon> Programmer l'événement</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'EventDuplicate', params: {id: cell.item.id } }"><font-awesome-icon icon="clone"></font-awesome-icon> Dupliquer l'événement</b-dropdown-item>
              <b-dropdown-item @click.stop="showHistory(cell.item, $event.target)"><font-awesome-icon icon="history"></font-awesome-icon> Voir l'historique des modifications</b-dropdown-item>
            </b-dropdown>
            <!-- <router-link tag="a" class="btn btn-sm btn-primary" :to="{ name: 'EventEditExist', params: {id: cell.item.id } }" v-show="cell.item.date_deleted == undefined">
              Editer
            </router-link>
            <b-button size="sm" variant="danger" @click.stop="info(cell.item, cell.index, $event.target)" class="mr-1" v-show="cell.item.date_deleted == undefined || role == 'admin'">
              Supprimer
            </b-button>
            <b-button size="sm" variant="info" @click.prevent="enableEvent(cell.item)" class="mr-1" v-show="cell.item.date_deleted != undefined && role == 'admin'">Rétablir l'événement</b-button> -->
          </template>
          <template slot="show_details" slot-scope="row">
            <b-button size="sm" @click.prevent="getInfoSalesforce(row.item); row.toggleDetails()" class="mr-2">
            {{ row.detailsShowing ? 'Cacher' : 'Voir'}} les détails
            </b-button>
          </template>
          <template slot="row-details" slot-scope="row">
            <b-card :class="theme">
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Etablissement :</b></b-col>
                <b-col>{{ row.item.establishment.school.name }} {{ row.item.establishment.city.name }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Type :</b></b-col>
                <b-col>{{ row.item.type.name }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Label :</b></b-col>
                <b-col>{{ row.item.label != undefined ? row.item.label.name : '' }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Date de début :</b></b-col>
                <b-col>{{ row.item.start_date | formatDate }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Date de fin :</b></b-col>
                <b-col>{{ row.item.end_date | formatDate }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Horaire de début :</b></b-col>
                <b-col>{{ row.item.start_time }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Horaire de fin :</b></b-col>
                <b-col>{{ row.item.end_time }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Lieu de l'événement :</b></b-col>
                <b-col>{{ row.item.address }} {{ row.item.postal_code }} {{ row.item.city }} <a :href="row.item.google_map" target="_blank">{{ row.item.google_map }}</a></b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Contact e-mail :</b></b-col>
                <b-col>{{ row.item.contact }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Description :</b></b-col>
                <b-col v-html="row.item.description"><!--{{ row.item.description }}--></b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>URL :</b></b-col>
                <b-col>{{ row.item.link_name }} {{ row.item.link != undefined ? ' >> ' : '' }} <a :href="row.item.link != undefined ? row.item.link.name : ''" target="_blank">{{ row.item.link != undefined ? row.item.link.name : '' }}</a></b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Image :</b></b-col>
                <b-col><img :src="row.item.image != undefined ? row.item.image.name : ''" height="50" /></b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>URL Salesforce :</b></b-col>
                <b-col v-show="row.item.establishment.school.id === '5d96008feaa7db53c25b8dd3'"><a :href="'https://ioniseducationgroup.lightning.force.com/' + row.item.salesforce_campaign" target="_blank" v-show="row.item.salesforce_campaign != ''">https://ioniseducationgroup.lightning.force.com/{{ row.item.salesforce_campaign }}</a></b-col>
                <b-col v-show="row.item.establishment.school.id !== '5d96008feaa7db53c25b8dd3'"><a :href="'https://ionis.lightning.force.com/' + row.item.salesforce_campaign" target="_blank" v-show="row.item.salesforce_campaign != ''">https://ionis.lightning.force.com/{{ row.item.salesforce_campaign }}</a></b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Evénement actif :</b></b-col>
                <b-col>{{ row.item.active ? 'Oui' : 'Non' }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Planifié pour le :</b></b-col>
                <b-col>{{ row.item.date_planned | formatDate }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Crée par :</b></b-col>
                <b-col>{{ row.item.ionis.first_name }} {{ row.item.ionis.last_name }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Evénement crée le :</b></b-col>
                <b-col>{{ row.item.date_created | formatDateTime }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Evénement modifié le :</b></b-col>
                <b-col>{{ row.item.date_updated | formatDateTime }}</b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Evénement supprimé le :</b></b-col>
                <b-col>{{ row.item.date_deleted | formatDateTime }}</b-col>
              </b-row>
              <!-- <b-row class="mb-2" v-show="row.item.salesforce_campaign != '' || row.item.salesforce_campaign != undefined">
                <b-col sm="3" class="text-sm-right"><b>Valeurs dans Salesforce</b></b-col>
                <b-col sm="9">
                  <p>Nom de la campagne :<br />
                  Ecole :<br />
                  Division :<br />
                  Campus :<br />
                  Date de début :<br />
                  Date de fin :<br />
                  Heure de début :<br />
                  Heure de fin :<br />
                  Type :<br />
                  Nature de l'événement :<br />
                  Description :<br />
                  Actif :<br />
                  URL Webinaire :</p>
                </b-col>
              </b-row> -->
              <b-button size="sm" @click.prevent="row.toggleDetails">Cacher les détails</b-button>
              <router-link tag="button" class="btn btn-sm btn-primary" :to="{ name: 'EventDuplicate', params: {id: row.item.id } }">
                Dupliquer l'événement
              </router-link>
              <b-button size="sm" variant="info" @click.stop="infoEvent(row.item, row.index, $event.target)" class="mr-1">
                Voir le JSON
              </b-button>
            </b-card>
          </template>
        </b-table>

        <div class="text-center" v-show="spinner">
          <b-spinner style="width: 3rem; height: 3rem;"></b-spinner> Chargement des événements
        </div>

        <b-row v-show="totalRows > perPage">
          <b-col md="6" class="my-1">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>

        <!-- Info modal -->
        <b-modal id="modalInfo" @hide="resetModal" :ok-disabled="eventsToNotDelete.length > 0"  @ok="handleOk(modalInfo.item); modifyEventSF(modalInfo.item, false)" :title="modalInfo.title" ok-variant="danger" ok-title="Supprimer" cancel-title="Annuler">
          <b-alert variant="warning" :show="eventsToNotDelete.length > 0">
            Cet événement ne peut pas être supprimé car une campagne Salesforce a été créée et des prospects ont été ajoutés à cette campagne. Merci de contacter l'équipe Salesforce Ionis.
          </b-alert>
          {{ modalInfo.content }}
          <!-- <div class="custom-control custom-checkbox mt-3">
            <input type="checkbox" class="custom-control-input" id="checkboxPopup">
            <label class="custom-control-label" for="checkboxPopup" style="color:#212529">
              Ne plus afficher cette popup pour les prochaines suppressions
            </label>
          </div> -->
        </b-modal>
        <b-modal id="modalDelete" @hide="resetModal" size="lg" @ok="handleDeleteAll(modalInfo.item); modifyEventSF(modalInfo.item, false)" :title="modalInfo.title" ok-variant="danger" ok-title="Supprimer" cancel-title="Annuler">
          <b-alert variant="warning" :show="eventsToNotDelete.length > 0">
            Certains événements sélectionnés ne seront pas supprimés car une campagne Salesforce a été créée et des prospects ont été ajoutés à cette campagne. Merci de contacter l'équipe Salesforce Ionis.
          </b-alert>
          {{ modalInfo.content }}
          <ul class="mt-2">
            <li v-for="item in selected" :key="item.id">{{ item.type.name }} à {{ item.establishment.school.name }} {{ item.establishment.city.name }} le {{ item.start_date | formatDate }} {{ item.start_time }} {{ item.end_time }} <strong class="text-danger" v-show="eventsToNotDelete.includes(item.id)">- Evénement non supprimé</strong></li>
          </ul>
        </b-modal>
        <b-modal id="modalInfoEvent" @hide="resetModal" :title="modalInfo.title" ok-only>
          <pre>{{ modalInfo.content }}</pre>
        </b-modal>
        <b-modal id="modalHistoryEvent" @hide="resetModal" :title="modalInfo.title" ok-only>
          <b-table :fields="fieldsHistory" :items="modalInfo.item">
            <template slot="date" slot-scope="cell">
              {{ cell.item.date | formatDateTime }}
            </template>
            <template slot="type" slot-scope="cell">
              {{ cell.item.name }}
            </template>
            <template slot="user" slot-scope="cell">
              {{ cell.item.ionis.first_name }} {{ cell.item.ionis.last_name }}
            </template>
          </b-table>
        </b-modal>
        <b-modal id="modalScheduleEvent" @hide="resetModal" :title="modalInfo.title" :ok-disabled="!date_planned && !modalInfo.item.date_planned" ok-title="Programmer" ok-variant="warning" cancel-title="Annuler" @cancel="cancelScheludeEvent" @ok="updateScheludeEvent(modalInfo.item.id)">
          <datepicker id="date_planned" name="date_planned" v-model="date_planned" input-class="form-control" format="dd/MM/yyyy" placeholder="Date prévue pour mise en ligne" :language="fr" :monday-first="true" :clear-button="true" :highlighted="highlightedDate" data-vv-as="Date de mise en ligne"></datepicker>
        </b-modal>
        <p class="text-center mt-3" v-show="totalRows == 0 && !spinner"><em>Il y a aucun événement pour le moment...</em></p>
      </b-tab>
      <b-tab title="Vue agenda">
        <vue-event-calendar :events="calendar"></vue-event-calendar>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import { fr } from 'vuejs-datepicker/dist/locale'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowUp, faCalendar, faCheckCircle, faClock, faClone, faCog, faFileExport, faFileImport, faFilter, faHistory, faPencilAlt, faTimesCircle, faTrash, faTrashRestore } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vueEventCalendar from 'vue-event-calendar'
import 'vue-event-calendar/dist/style.css'
import Papa from 'papaparse'
import download from 'downloadjs'
import Salesforce from '../../class/Salesforce'

library.add(faArrowUp, faCalendar, faCheckCircle, faClock, faClone, faCog, faFileExport, faFileImport, faFilter, faHistory, faPencilAlt, faTimesCircle, faTrash, faTrashRestore)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueResource)
Vue.use(vueEventCalendar, {locale: 'fr', color: 'black', weekStartOn: 1})

Vue.filter('formatDate', function (value) {
  let date = new Date(value)
  if (value) {
    return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()
  }
  return value
})

Vue.filter('formatDateTime', function (value) {
  let date = new Date(value)
  if (value) {
    return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear() + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2)
  }
  return value
})

export default {
  data () {
    return {
      advance: false,
      advancePara: false,
      bachelor: false,
      calendar: [],
      cityId: '',
      // cities: [],
      cpge: false,
      currentPage: 1,
      date_debut: '',
      date_fin: '',
      date_planned: '',
      events: [],
      eventsToNotDelete: [],
      fields: {
        type: {
          label: 'Type',
          key: 'type.name',
          sortable: true
        },
        label: {
          label: 'Label',
          key: 'label.name',
          sortable: true
        },
        active: {
          label: 'Actif',
          sortable: false
        },
        highlight: {
          label: 'Mise en avant',
          sortable: false
        },
        school: {
          label: 'Ecole',
          key: 'establishment.school.name',
          sortable: true
        },
        city: {
          label: 'Ville',
          key: 'establishment.city.name',
          sortable: true
        },
        start_date: {
          label: 'Date',
          sortable: true
        },
        horaire: {
          label: 'Horaire',
          sortable: false
        },
        author: {
          label: 'Crée par',
          sortable: false
        },
        actions: {
          label: 'Actions',
          key: 'actions',
          tdClass: 'actions'
        },
        show_details: {
          label: 'Détails'
        }
      },
      fieldsHistory: {
        date: {
          label: 'Date'
        },
        type: {
          label: 'Type'
        },
        user: {
          label: 'Utilisateur'
        }
      },
      filter: '',
      fr: fr,
      highlightedDate: {
        dates: [
          new Date()
        ]
      },
      isBusy: false,
      labelId: '',
      labels: [],
      modalInfo: { content: '', item: '', title: '' },
      perPage: 25,
      schoolId: '',
      // schools: [],
      selected: [],
      showActive: 1,
      showOptions: [
        { value: 0, text: 'Tous les événements' },
        { value: 1, text: 'Les événements actifs' },
        { value: 2, text: 'Les événements inactifs' },
        { value: 3, text: 'Les événements en attente' },
        { value: 4, text: 'Les événements passés' }
      ],
      // showPassed: [],
      // showInactive: [],
      showFilter: true,
      spinner: true,
      typeId: '',
      types: [],
      ionisId: '',
      users: []
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'cities', 'domain', 'establishments', 'list_filter', 'role', 'schools', 'theme', 'userId']),
    columnFilter () {
      if (this.schools.length > 1) {
        if (this.hasFilter) {
          return 2
        } else {
          return 3
        }
      } else {
        if (this.hasFilter) {
          return 3
        } else {
          return 4
        }
      }
    },
    end_date () {
      // let date = new Date(this.date_debut)
      if (this.date_fin) {
        return new Date(this.date_fin).toISOString().substring(0, 10)
        // return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()
      }
      return this.date_fin
    },
    filter_events () {
      return this.events.filter(
        (event) => {
          let today = new Date(new Date().setHours(0, 0, 0, 0)).toISOString()
          return (
            (event.end_time.toLowerCase().includes(this.filter.toLowerCase()) || event.establishment.city.name.toLowerCase().includes(this.filter.toLowerCase()) || event.establishment.school.name.toLowerCase().includes(this.filter.toLowerCase()) || event.ionis.first_name.toLowerCase().includes(this.filter.toLowerCase()) || event.ionis.last_name.toLowerCase().includes(this.filter.toLowerCase()) || (event.label !== undefined && event.label.name.toLowerCase().includes(this.filter.toLowerCase())) || event.start_time.toLowerCase().includes(this.filter.toLowerCase()) || event.type.name.toLowerCase().includes(this.filter.toLowerCase()) || this.filter === '' || this.filter === null) &&
            ((this.schoolId !== '' && event.establishment.schoolId === this.schoolId) || this.schoolId === '') &&
            ((this.cityId !== '' && event.establishment.cityId === this.cityId) || this.cityId === '') &&
            ((this.typeId !== '' && event.typeId === this.typeId) || this.typeId === '') &&
            ((this.labelId !== '' && event.labelId === this.labelId) || this.labelId === '') &&
            ((this.ionisId !== '' && event.ionisId === this.ionisId) || this.ionisId === '') &&
            // ((this.advance !== '' && event.advance === this.advance) || !this.isAdvance) &&
            ((this.advance === false && (event.advance === false || event.advance === true)) || (this.advance === event.advance)) &&
            ((this.advancePara === false && (event.advancePara === false || event.advancePara === true)) || (this.advancePara === event.advancePara)) &&
            ((this.cpge === false && (event.cpge === false || event.cpge === true)) || (this.cpge === event.cpge)) &&
            ((this.bachelor === false && (event.bachelor === false || event.bachelor === true)) || (this.bachelor === event.bachelor)) &&
            // (((this.start_date !== undefined || this.start_date !== null) && event.start_date.substring(0, 10) === this.start_date) || this.start_date === undefined || this.start_date === null) &&
            // (((this.end_date !== undefined || this.end_date !== null) && event.end_date !== undefined && event.start_date.substring(0, 10) >= this.end_date) || this.end_date === undefined || this.end_date === null) &&
            (((this.start_date !== null || this.end_date === null) && (event.start_date.substring(0, 10) === this.start_date || this.end_date !== null)) || this.start_date === null) &&

            ((this.start_date !== null && this.end_date !== null && event.start_date.substring(0, 10) >= this.start_date && event.start_date.substring(0, 10) <= this.end_date) || this.start_date === undefined || this.start_date === null || this.end_date === undefined || this.end_date === null) &&

            ((event.active === true && this.showActive === 1 && ((event.end_date !== undefined && new Date(event.end_date).toISOString() > today) || new Date(event.start_date).toISOString() > today)) || this.showActive !== 1) &&
            ((event.active === false && this.showActive === 2 && event.date_planned === undefined) || this.showActive !== 2) &&
            ((event.active === false && this.showActive === 3 && event.date_planned !== undefined) || this.showActive !== 3) &&
            ((event.active === true && this.showActive === 4 && new Date(event.start_date).toISOString() < today) || this.showActive !== 4) &&
            // (event.active === (this.showInactive.length === 0)) &&
            // ((event.end_date !== undefined && new Date(event.end_date).toISOString() > today && this.showPassed.length === 0) || (new Date(event.start_date).toISOString() > today && this.showPassed.length === 0) || (new Date(event.start_date).toISOString() < today && this.showPassed.length === 1)) &&
            (!event.deleted)
          )
        }
      )
    },
    filter_events_export () {
      let events = []
      // On parcour tout et on remplace les objets par des valeurs
      for (let [key] of Object.entries(this.filter_events)) {
        let objects = {}
        for (let [key2, value2] of Object.entries(this.filter_events[key])) {
          let object = {}
          if (typeof value2 === 'object') {
            for (let [key3, value3] of Object.entries(this.filter_events[key][key2])) {
              if (key3 === 'name' && key2 !== 'image') {
                object[key2] = value3
              }
            }
          } else if (typeof value2 === 'boolean') {
            object[key2] = value2 ? 'Oui' : 'Non'
          } else if (key2.indexOf('Id') === -1 && value2 !== 'undefined') {
            object[key2] = value2
          }

          Object.assign(objects, object)
        }
        events.push(objects)
      }
      return events
    },
    hasFilter () {
      return this.cityId !== '' || (this.schoolId !== '' && this.schools.length > 1) || this.typeId !== '' || this.date_debut !== null || this.date_fin !== null
    },
    isAdvance () {
      return this.schoolId === '5b9bcb3990c8a831489aefd0' || this.schoolId === '5b9bcb4690c8a831489aefd1' || this.schoolId === '5b9bcb4a90c8a831489aefd2' || this.schoolId === '5b9bcb4f90c8a831489aefd3' || this.role === 'admin'
    },
    isBachelor () {
      return this.schoolId === '5b9bcb3990c8a831489aefd0' || this.schoolId === '5b9bcb4690c8a831489aefd1' || this.schoolId === '5b9bcb4a90c8a831489aefd2' || this.schoolId === '5b9bcb4f90c8a831489aefd3' || this.role === 'admin'
    },
    isCpge () {
      return this.schoolId === '5b9bcb3990c8a831489aefd0' || this.schoolId === '5b9bcb4690c8a831489aefd1' || this.schoolId === '5b9bcb4a90c8a831489aefd2' || this.role === 'admin'
    },
    numberFilter () {
      let number = 0
      if (this.schoolId !== '' && this.schools.length > 1) number++
      if (this.cityId !== '') number++
      if (this.typeId !== '') number++
      if (this.labelId !== '') number++
      if (this.ionisId !== '') number++
      if (this.date_debut !== null) number++
      if (this.date_fin !== null) number++

      return number === 0 ? '' : number
    },
    pageOptions () {
      let options = [ 25, 50, 100 ]
      if (this.filter_events.length > 100) {
        options.push(this.filter_events.length)
      }
      return options
    },
    showLabel () {
      return this.schoolId !== '' && this.typeId !== ''
    },
    start_date () {
      // let date = new Date(this.date_debut)
      if (this.date_debut) {
        return new Date(this.date_debut).toISOString().substring(0, 10)
        // return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()
      }
      return this.date_debut
    },
    totalRows () {
      return this.filter_events.length
    }
  },
  methods: {
    ...Vuex.mapActions(['addFilter', 'addRole']),
    test () {
      this.$tours['myTour'].start()
    },
    cancelScheludeEvent () {
      this.date_planned = ''
    },
    checkCampaignMember (items) {
      let salesforce = new Salesforce()
      console.log(items)
      if (items[0].establishment.schoolId !== '5d96008feaa7db53c25b8dd3') {
        salesforce.login().then(
          (value) => {
            salesforce.getLeadCampaignMember(items).then(
              (value) => {
                this.eventsToNotDelete = value
              },
              (value) => {

              }
            )
          },
          (value) => {

          }
        )
      }

      if (items[0].establishment.schoolId === '5d96008feaa7db53c25b8dd3') {
        salesforce.login().then(
          (value) => {
            salesforce.getLeadCampaignMemberEda(items).then(
              (value) => {
                this.eventsToNotDelete = value
              },
              (value) => {

              }
            )
          },
          (value) => {

          }
        )
      }
    },
    exportData () {
      let file = Papa.unparse(this.filter_events_export, { delimiter: ';' })
      download(file, 'export.csv', 'application/octet-steam')
    },
    getData () {
      let where = ''
      // trouver une solution ? Afficher que les événements crées par l'utilisateur ?
      if (this.role !== 'admin') {
        for (let i = 0; i < this.establishments.length; i++) {
          where += '&filter[where][or][' + i + '][establishmentId]=' + this.establishments[i]
        }
      } else {
        where += '&filter[where][start_date][gte]=2024-01-01'
      }
      // Attention, au rechargement on affiche pas les événements. Bug sinon on afficherait tous les événements aux non admin
      if (this.role !== '') {
        this.$http.get(this.domain + '/api/events?filter[include][0]=type&filter[include][1][establishment]=school&filter[include][1][establishment]=city&filter[include][2]=ionis&filter[include][3]=label&filter[include][4]=link&filter[include][5]=image&filter[order]=start_date ASC' + where + '&access_token=' + this.access_token).then((response) => {
          response.json().then((data) => {
            this.events = data
            this.spinner = false
          })
        }, (response) => {

        })
      }
    },
    deleteEvent (item) {
      this.$http.delete(this.domain + '/api/events/' + item.id + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          if (response.status === 200 && response.ok) {
            // this.flash('L\'événement a bien été supprimé', 'success', { timeout: 3000 })
            this.$root.$bvToast.toast('L\'événement a bien été supprimé', {
              title: 'Evénement supprimé',
              autoHideDelay: 3000,
              append: false,
              variant: 'success'
            })
          }
        })
      }, (response) => {

      })
    },
    disableEvent (item) {
      // item.active = false
      // item.date_deleted = new Date().toISOString()
      this.$http.post(this.domain + '/api/events/update?where[id]=' + item.id + '&access_token=' + this.access_token, { date_deleted: new Date().toISOString(), active: false }, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          // this.flash('L\'événement a bien été supprimé', 'success', { timeout: 3000 })
          this.$root.$bvToast.toast('L\'événement a bien été supprimé', {
            title: 'Evénement supprimé',
            autoHideDelay: 3000,
            append: false,
            variant: 'success'
          })
        })
      }, (response) => {

      })
    },
    modifyEventSF (items, active) {
      let type = typeof items
      let schoolId = ''
      console.log(type)
      let sObject = []
      console.log('items', items, items.length)
      if (type !== 'object') {
        schoolId = items[0].establishment.schoolId
        for (let i = 0; i < items.length; i++) {
          console.log(items[i].salesforce_campaign)
          if (items[i].salesforce_campaign !== '') {
            console.log('coucou')
            sObject.push(
              {
                Id: items[i].salesforce_campaign,
                IsActive: active
              }
            )
          }
        }
      } else {
        schoolId = items.establishment.schoolId
        sObject.push(
          {
            Id: items.salesforce_campaign,
            IsActive: active
          }
        )
      }
      console.log(sObject)
      if (sObject.length > 0) {
        let salesforce = new Salesforce()
        if (schoolId !== '5d96008feaa7db53c25b8dd3') {
          salesforce.login().then(
            (value) => {
              salesforce.update(sObject).then(
                (value) => {

                },
                (value) => {

                }
              )
            },
            (value) => {

            }
          )
        }

        if (schoolId === '5d96008feaa7db53c25b8dd3') {
          salesforce.login().then(
            (value) => {
              salesforce.updateEda(sObject).then(
                (value) => {

                },
                (value) => {

                }
              )
            },
            (value) => {

            }
          )
        }
      }
    },
    emptyFilter () {
      this.cityId = ''
      this.schoolId = ''
      this.typeId = ''
      this.labelId = ''
      this.ionisId = ''
      this.date_debut = null
      this.date_fin = null
      this.updateFilter()
      this.updateType()
    },
    enableEvent (item) {
      this.$http.post(this.domain + '/api/events/update?where[id]=' + item.id + '&access_token=' + this.access_token, { date_deleted: null, active: false }, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          // this.flash('L\'événement a bien été rétabli', 'success', { timeout: 3000 })
          this.$root.$bvToast.toast('L\'événement a bien été rétabli', {
            title: 'Evénement rétabli',
            autoHideDelay: 3000,
            append: false,
            variant: 'success'
          })
        })
      }, (response) => {

      })
    },
    getInfoSalesforce (item) {
      console.log(item)
    },
    handleDeleteAll () {
      for (let i = 0; i < this.selected.length; i++) {
        // console.log(this.selected[i])
        // Condition si l'événement untel doit pas être supprimé
        if (!this.eventsToNotDelete.includes(this.selected[i].id)) {
          this.handleOk(this.selected[i])
        }
      }
    },
    handleOk (item) {
      console.log(item)
      for (let i = 0; i < this.events.length; i++) {
        if (this.events[i].id === item.id) {
          this.events.splice(i, 1)
        }
      }
      if (this.role === 'admin') {
        this.deleteEvent(item)
      } else {
        this.disableEvent(item)
      }
    },
    onRowSelected (items) {
      this.selected = items
      this.checkCampaignMember(items)
    },
    info (item, index, button) {
      this.modalInfo.content = 'Etes-vous vraiment sûr de supprimer cet événement ?'
      this.modalInfo.item = item
      this.modalInfo.title = 'Suppression de l\'événement'
      // this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    infoDeleteMultiple (button) {
      console.log('khgsdkghsdklhlsghskdlgsdhdlsghlksdhlhlsdkhdshkldsghdgklshlksg')
      this.modalInfo.content = 'Etes-vous vraiment sûr de supprimer les événements sélectionnés ?'
      this.modalInfo.item = this.selected
      this.modalInfo.title = 'Suppression des événements'

      this.$root.$emit('bv::show::modal', 'modalDelete', button)
    },
    infoEvent (item, index, button) {
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.modalInfo.title = 'JSON de l\'événement'
      this.$root.$emit('bv::show::modal', 'modalInfoEvent', button)
    },
    resetModal () {
      this.modalInfo.item = ''
      this.modalInfo.content = ''
      this.modalInfo.title = ''
    },
    scheduleEvent (item, index, button) {
      this.modalInfo.title = 'Programmation de l\'événement'
      this.modalInfo.item = item
      this.date_planned = item.date_planned
      this.$root.$emit('bv::show::modal', 'modalScheduleEvent', button)
    },
    showHistory (item, button) {
      this.modalInfo.title = 'Historique des modifications'
      console.log('cidcickkk', item.id)
      // this.$http.get(this.domain + '/api/logs?where?filter[where][eventId]=' + item.id + '&access_token=' + this.access_token)
      this.$http.get(this.domain + '/api/logs?filter[where][eventId]=' + item.id + '&filter[include]=ionis&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.modalInfo.item = data
        })
      }, (response) => {

      })
      this.$root.$emit('bv::show::modal', 'modalHistoryEvent', button)
    },
    showingFilter () {
      this.showFilter = !this.showFilter
    },
    switchHighlight (item) {
      this.$http.post(this.domain + '/api/events/update?where[id]=' + item.id + '&access_token=' + this.access_token, { highlighted: !item.highlighted }, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.getData()
          // this.flash('L\'événement a bien été modifié', 'success', { timeout: 3000 })
          this.$root.$bvToast.toast('L\'événement a bien été modifié', {
            title: 'Evénement modifié',
            autoHideDelay: 3000,
            append: false,
            variant: 'success'
          })
        })
      }, (response) => {

      })
    },
    switchHighlightSlider (item) {
      this.$http.post(this.domain + '/api/events/update?where[id]=' + item.id + '&access_token=' + this.access_token, { slider: !item.slider }, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.getData()
          // this.flash('L\'événement a bien été modifié', 'success', { timeout: 3000 })
          this.$root.$bvToast.toast('L\'événement a bien été modifié', {
            title: 'Evénement modifié',
            autoHideDelay: 3000,
            append: false,
            variant: 'success'
          })
        })
      }, (response) => {

      })
    },
    switchStatus (item) {
      this.$http.post(this.domain + '/api/events/update?where[id]=' + item.id + '&access_token=' + this.access_token, { active: !item.active }, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.modifyEventSF(item, !item.active)
          this.getData()
          // this.flash('L\'événement a bien été modifié', 'success', { timeout: 3000 })
          this.$root.$bvToast.toast('L\'événement a bien été modifié', {
            title: 'Evénement modifié',
            autoHideDelay: 3000,
            append: false,
            variant: 'success'
          })
        })
      }, (response) => {

      })
    },
    updateFilter () {
      this.addFilter({ city: this.cityId, school: this.schoolId, type: this.typeId, label: this.labelId, date_debut: this.date_debut, date_fin: this.date_fin })
    },
    updateLabel () {
      if (this.schoolId !== '' && this.typeId !== '') {
        this.labels = []
        // Récupération des labels en fonction de l'école et du type
        this.$http.get(this.domain + '/api/labels?access_token=' + this.access_token + '&filter[where][schoolId]=' + this.schoolId + '&filter[where][typeId]=' + this.typeId + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            this.labels = data
            let exist = false
            for (let i = 0; i < data.length; i++) {
              if (data[i].id === this.labelId) {
                exist = true
              }
              if (!exist) {
                this.labelId = ''
              }
            }
          })
        }, (response) => {

        })
      } else {
        this.labelId = ''
      }
    },
    updateScheludeEvent (id) {
      let active = !this.date_planned
      console.log(this.date_planned)
      let datePlanned = new Date(this.date_planned).toISOString().substring(0, 10)
      this.$http.post(this.domain + '/api/events/update?where[id]=' + id + '&access_token=' + this.access_token, { date_planned: datePlanned, active: active }, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.getData()
          // this.flash('L\'événement a bien été modifié', 'success', { timeout: 3000 })
          this.$root.$bvToast.toast('L\'événement a bien été modifié', {
            title: 'Evénement modifié',
            autoHideDelay: 3000,
            append: false,
            variant: 'success'
          })
        })
      }, (response) => {

      })
    },
    updateType () {
      this.types = []
      this.$http.get(this.domain + '/api/types?filter[order]=name asc&access_token=' + this.access_token).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            if (this.schoolId === '') {
              for (let j = 0; j < this.schools.length; j++) {
                let type = data[i].schools.find(a => a.id === this.schools[j].id)
                let typeActual = this.types.find(a => a.id === data[i].id)
                if (type !== undefined && typeActual === undefined) {
                  this.types.push({
                    id: data[i].id,
                    name: data[i].name
                  })
                }
              }
            } else {
              let type = data[i].schools.find(a => a.id === this.schoolId)
              if (type !== undefined) {
                this.types.push({
                  id: data[i].id,
                  name: data[i].name
                })
              }
            }
          }
          // On cherche si le type sélectionné existe dans la liste
          if (this.typeId !== '') {
            let type = this.types.find(a => a.id === this.typeId)
            if (type === undefined) {
              this.typeId = ''
            }
          }
        })
      }, (response) => {

      })
    }
  },
  watch: {
    filter_events (value, oldValue) {
      if (value.toString() !== oldValue.toString()) {
        this.isBusy = true
        this.calendar = []
        for (let i = 0; i < value.length; i++) {
          let date = value[i].start_date.substring(0, 10).replace(/-/g, '/')
          let label = value[i].label !== undefined ? value[i].label.name : ''
          this.calendar.push({
            date: date,
            title: value[i].establishment.school.name + ' ' + value[i].establishment.city.name + ' - ' + label,
            desc: value[i].description
          })
        }
        setTimeout(() => {
          this.isBusy = false
        }, 500)
      }
    },
    role (value) {
      this.getData()
    }
  },
  mounted () {
    // if (this.$route.query.event === 'added') {
    //   this.flash('L\'événement a bien été ajouté', 'success', { timeout: 3000 })
    // }
    // if (this.$route.query.event === 'edit') {
    //   this.flash('L\'événement a bien été modifié', 'success', { timeout: 3000 })
    // }
    this.getData()

    // Filtres
    this.cityId = this.list_filter.city
    this.schoolId = this.list_filter.school
    this.typeId = this.list_filter.type
    this.labelId = this.list_filter.label
    this.date_debut = this.list_filter.date_debut
    this.date_fin = this.list_filter.date_fin

    // this.$http.get(this.domain + '/api/schools?filter[order]=name asc&access_token=' + this.access_token).then((response) => {
    //   response.json().then((data) => {
    //     this.schools = data
    //   })
    // }, (response) => {

    // })

    // this.$http.get(this.domain + '/api/cities?filter[order]=name asc&access_token=' + this.access_token).then((response) => {
    //   response.json().then((data) => {
    //     this.cities = data
    //   })
    // }, (response) => {

    // })
    // if (this.role === 'admin') {
    //   this.$http.get(this.domain + '/api/types?filter[order]=name asc&access_token=' + this.access_token).then((response) => {
    //     response.json().then((data) => {
    //       this.types = data
    //     })
    //   }, (response) => {

    //   })
    // }

    this.$http.get(this.domain + '/api/ionis?filter[order]=first_name asc&access_token=' + this.access_token).then((response) => {
      response.json().then((data) => {
        this.users = data
      })
    }, (response) => {

    })

    if (this.schools.length === 1) {
      this.schoolId = this.schools[0].id
    }

    this.updateType()
    this.updateLabel()

    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (this.filter_events.length < 4) {
        let action = document.getElementsByClassName('actions')
        for (let i = 0; i < action.length; i++) {
          action[i].style.height = '250px'
        }
      }
    })

    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (this.filter_events.length < 4) {
        let action = document.getElementsByClassName('actions')
        for (let i = 0; i < action.length; i++) {
          action[i].style.height = 'initial'
        }
      }
    })
  }
}
</script>

<style lang="scss">
  [data-icon="check-circle"], [data-icon="times-circle"] {
    cursor: pointer;
  }
  // .actions {
  //   height: 200px;
  // }
</style>



// WEBPACK FOOTER //
// src/components/Events/List.vue